<template>
  <div class="block-separator">
    <div class="block-separator__text">
      <slot></slot>
    </div>
    <div class="block-separator__line" :class="{'block-separator__line--dashed': dashed}"></div>
  </div>
</template>

<script>
export default {
  props: {
    dashed: Boolean
  }
}
</script>

<style lang="scss" scoped>
.block-separator {
  width: 100%;
  margin-bottom: 25px;

  &__text {
    font-family: "Work Sans";
    color: $inactiveGrey;
    text-align: left;
    margin: 0px 0 10px 0;
  }

  &__line {
    width: 90%;
    margin: 5px auto 15px auto;
    border-bottom: solid 1px $borderGrey;

    &--dashed{
      border-bottom-style: dashed;
    }
  }
}
</style>
